import { CODE_ENV, CURRENT_CODE_ENV, isServer } from "./constant";

function loadScript(src: string) {
  if (typeof document === 'undefined') {
    console.warn('[vconsole] Document not available, skipping script load');
    return;
  }
  const script = document.createElement("script");
  script.src = src;
  document.head.appendChild(script);
}

const VCONSOLE_URL = "https://s3plus.meituan.net/cube-hfe-assets/static/vconsole.min.js";
const APPMOCK_URL = "https://s3plus.sankuai.com/v1/mss_e2fc5719a5b64fa4b3686b72e677a48e/wm-h5-appmock/h5mock.min.js"

export default function initVConsole() {
  if (CURRENT_CODE_ENV !== CODE_ENV.PRODUCTION && !isServer) {
    loadScript(VCONSOLE_URL)
    loadScript(APPMOCK_URL)
  }
}
